/* eslint-disable no-use-before-define */
import React, { useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Modal, Button } from 'ancestry-ui-react';
import m from './messages';
import { useHistory } from 'react-router-dom';

import {
  // actions
  closePopup, showPopup,
  //selectors
  isOpenedSelector, loadingSelector, contentSelector, errorSelector
} from '../../ducks/popup';

export function useHookWithRefCallback(dispatch, locale) {
  const ref = useRef(null);
  const history = useHistory();

  const setRef = useCallback(node => {
    const node$ = (node) || ref.current;
    const selector = '[href*="<%= BoardSettings.BoardsUrlPrefix %>"], [href*="<%= BoardSettings.CommunityUrlPrefix %>"]';
    const click$ = node$.querySelectorAll(selector);
    //Defect DE75761

    const btn = node$.querySelector('button.link');
    const isHelpSection = node$.querySelector('#morehelp');

    if (btn && isHelpSection) {
      btn.removeAttribute('onclick');
      btn.addEventListener('click', () => {
        window.location.href = '/boards/topics.rw.admin.busers';
      });
    }
    const anchorTags = node$.querySelectorAll('a'); //[href*="#"]
    const jsLinks = node$.querySelectorAll('a[href^="javascript:"]');

    if (ref.current) {
      click$.forEach(link => link.removeEventListener('click', handleLinkClick));
      jsLinks.forEach(link => link.removeEventListener('click', handleJsLinkClick));
      //Defect DE75761
      anchorTags.forEach(anchorTag => {
        anchorTag.removeEventListener('click', handleHashLinkClick);
        anchorTag.removeEventListener('keydown', handleKey);
      });
      //
    }

    if (node) {
      click$.forEach(link => link.addEventListener('click', handleLinkClick));
      jsLinks.forEach(link => link.addEventListener('click', handleJsLinkClick));
      //Defect DE75761
      anchorTags.forEach(anchorTag => {
        anchorTag.addEventListener('click', event => {
          handleHashLinkClick(event, anchorTags);
        });
        anchorTag.addEventListener('keydown', event => {
          handleKey(event, anchorTags);
        });
      });
      //
    }
    // Save a reference to the node
    ref.current = node;
  }, []);

  //Defect DE75761
  const handleHashLinkClick = (event, linkTags) => {
    const link = event.currentTarget;
    const linkid = link.hash.split('#')[1];
    const linkTag = document.querySelector(`[id="${linkid}"]`);
    const targetElement = findLinkTagFromSiblingElement(linkTag);
    let isTargetEle = false;
    linkTags.forEach((element, index) => {
      if (element !== targetElement && !isTargetEle) {
        element.setAttribute('tabindex', -1);
      } else {
        isTargetEle = true;
        element.setAttribute('tabindex', 0);
      }
    });
    if (!isTargetEle) {
      linkTags[linkTags.length - 1].setAttribute('tabindex', 0);
    }
  };

  const handleKey = (event, anchorTags) => {
    if (event.keyCode === 9) {
      const shiftKey = event.shiftKey;
      let preNode = null;
      anchorTags.forEach((ele, i) => {
        if (event.currentTarget === ele) {
          preNode = i > 0 ? anchorTags[i - 1] : anchorTags[i];
        }
      });
      if (shiftKey) {
        preNode.setAttribute('tabindex', 0);
      }
    }
  };

  const handleJsLinkClick = event => {
    event.preventDefault();
    const href = event.currentTarget.getAttribute('href');
    if (/javascript:lists\(\)/i.test(href)) {
      window.open('http://lists.rootsweb.com/', '_blank');
    }
  };

  const handleLinkClick = event => {
    const link = event.currentTarget;
    const href = link.getAttribute('href');
    const target = link.getAttribute('target');
    const url = new URL(href || '', window.location.origin);

    const isInternalLink = url.origin === window.location.origin;
    const isOpenedInSameWindow = !target || target === '_self';
    const isLeftButtonClick = event.button === 0;
    const isModifierKeyPressed = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

    if (
      isInternalLink
      && isOpenedInSameWindow
      && isLeftButtonClick
      && !isModifierKeyPressed
    ) {
      event.preventDefault();

      const redirectUrl = getRedirectUrl(link);

      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }
      dispatch(closePopup());

      const hash = link.hash;
      const popupName = getPopupName(link);
      staticModalRedirect({ popupname: popupName, hash });
    }
  };

  const getPopupName = link => {
    if (link.pathname.includes('boardfaq.aspx')) {
      return 'FAQ';
    }

    if (link.pathname.includes('boardhelp.aspx')) {
      return 'HELP';
    }
  };

  const getRedirectUrl = link => {
    if (link.pathname.includes('guidelines.aspx')) {
      return `/c/legal/community-rules?geo-lang=${locale}`;
    }
    return null;
  };

  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

  const staticModalRedirect = async args => {
    await delay(200);
    dispatch(showPopup(args.popupname));
    if (typeof args.hash === 'string' && args.hash !== '') {
      const response = await retryFunc(findNodeAsyncFunction.bind(this, args, 1000), 5);
      const result = await response();
      result.node[0].click();
      return;
    }
    history.push(args.hash);
  };

  return [setRef];
}

const retryFunc = (fun, reties) => {
  let attempt = 0;
  const doTry = (...args) => {
    attempt++;
    return fun(...args)
      .catch(err => {
        if (attempt <= reties) {
          return doTry(...args);
        }

        return Promise.reject(err);
      });
  };
  return doTry;
};

const findNodeAsyncFunction = (args, delay) => new Promise((resolve, reject) => {
  setTimeout(() => {
    const node$ = document.querySelectorAll(`div.con [href*='${args.hash}']`);
    (node$.length > 0) ? resolve({ node: node$ }) : reject({ node: node$ });
  }, delay);
});

// Defect DE75761
const findLinkTagFromSiblingElement = node => {
  let anode = null;
  if (node) {
    if (node.childElementCount === 0) {
      return findLinkTagFromSiblingElement(node.nextElementSibling);
    } else {
      let isNodeAvailable = false;
      for (let i = 0; i < node.childElementCount; i++) {
        if (node.children[i].nodeName === 'A' || node.children[i].nodeName === 'BUTTON' && !isNodeAvailable) {
          anode = node.children[i];
          isNodeAvailable = true;
        } else {
          let childOfChild = node.children[i];
          if (childOfChild.childElementCount > 0) {
            for (let cc = 0; cc < childOfChild.childElementCount; cc++) {
              console.log("childOfChild", childOfChild.children[cc]);
              if (childOfChild.children[cc].nodeName === 'A' || childOfChild.children[cc].nodeName === 'BUTTON' && !isNodeAvailable) {
                anode = childOfChild.children[cc];
                isNodeAvailable = true;
              }
            }
          }
        }
      }
      if (!anode) {
        return findLinkTagFromSiblingElement(node.nextElementSibling);
      }
    }
    return anode;
  }
};
//

function Popup(props) {
  const dispatch = useDispatch();
  const isOpen = useSelector(isOpenedSelector);
  const content = useSelector(contentSelector);
  const loading = useSelector(loadingSelector);
  const error = useSelector(errorSelector);
  const [ref] = useHookWithRefCallback(dispatch, props.intl.locale);

  const handleClosePopup = () => dispatch(closePopup());

  const getBody = () => {
    if (error) return <div>Oops, something happend wrong</div>;
    if (!content) return null;
    return <div ref={ref} dangerouslySetInnerHTML={{ __html: content }} />;
  };

  return (
    <Modal
      open={isOpen}
      hideCloseBtn
      closeOnBkgClick
      showLoading={!!loading}
      onClose={handleClosePopup}
    >
      <div className="popup-container__content-light">
        {getBody()}
      </div>
      {!loading && (
        <div className="popup-container__actions-light">
          <Button className="ancBtn silver" onClick={handleClosePopup}>
            <FormattedMessage {...m.closeModal} />
          </Button>
        </div>
      )}
    </Modal>
  );
}

export default injectIntl(Popup);
